import {
  alpha,
  createTheme,
  getContrastRatio,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material";
import type { PropsWithChildren } from "react";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3F5EFB",
      light: "#F0F3FF",
      dark: "#173ae8",
      contrastText: getContrastRatio("#3F5EFB", "#fff") > 4.5 ? "#fff" : "#111",
    },
    secondary: {
      main: "#F59000",
      light: "#FFE2B8",
      dark: alpha("#F59000", 0.9),
      contrastText: "#fff",
    },
    ternary: {
      main: "#5500A4",
      light: "#F2E3FF",
      dark: alpha("#5500A4", 0.9),
      contrastText: getContrastRatio("#5500A4", "#fff") > 4.5 ? "#fff" : "#111",
    },
    border: "#D9D9D9",
    caption: "#999999",
  },
  typography: {
    fontFamily: '"Roboto", "Montserrat", sans-serif',
    h2: {
      fontFamily: "Montserrat",
      fontWeight: 700,
      fontSize: "18px",
      marginBottom: "15px",
    },
    infoMain: {
      fontSize: "20px",
      color: "#1C1C1C",
      fontWeight: "bold",
      textTransform: "uppercase",
      wordBreak: "break-word",
      lineHeight: 1,
    },
    infoSub: {
      fontSize: "17px",
      color: "#1C1C1C",
      fontWeight: "500",
      wordBreak: "break-word",
      lineHeight: "25px",
    },
    caption: {
      lineHeight: "1.5",
      color: "#999999",
    },
    link: {
      color: "#3F5EFB",
      textDecoration: "underline",
      cursor: "pointer",
      fontWeight: "500",
    },
  },
});

const ThemeProvider = ({ children }: PropsWithChildren) => {
  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
